import React, { Component } from "react";
import {
  FieldGroup,
  FieldControl,
  Validators,
  FormBuilder
} from "react-reactive-form";
import { readableResponseMessage } from "ux-helpers";
import PropTypes from "proptypes";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";

export default class VerifyAccount extends Component {
  state = {
    successfulResendCode: false
  };

  componentDidMount() {
    window.scrollTo({
      top: 400,
      behavior: 'smooth',
    })
  }

  handleSubmit = (e, form) => {
    e.preventDefault();
    this.verifyAccount(form);
  };

  verifyAccount = async form => {
    if (this.verifyAccountForm.status === "VALID") {
      this.setState({ loadingBtn: true });
      this.verifyAccountForm.handleSubmit();
      const emailAddress = form.emailAddress
        ? form.emailAddress
        : this.props.userProps.emailAddress;
      Auth.confirmSignUp(emailAddress, form.verificationCode)
        .then(() => {
          this.props.setParentState("successfullyVerifiedAccount", true);
          this.props.history.push("/");
          //auto-login user after successful account verification
          this.props.autoLogin();
        })
        .catch(error => {
          this.setState({
            loadingBtn: false,
            message: readableResponseMessage(error)
          });
          this.verifyAccountForm.handleSubmit();
        });
    } else {
      this.verifyAccountForm.handleSubmit();
    }
  };

  verifyAccountForm = FormBuilder.group({
    emailAddress: [this.props.userProps.emailAddress],
    verificationCode: ["", Validators.required]
  });

  resendCode = async () => {
    const emailAddress = this.props.userProps.emailAddress
      ? this.props.userProps.emailAddress
      : this.verifyAccountForm.controls.emailAddress.value;
    if (emailAddress !== "") {
      Auth.resendSignUp(emailAddress)
        .then(() => {
          this.setState({ successfulResendCode: true });
          setTimeout(() => {
            this.setState({ successfulResendCode: false });
          }, 3000);
        })
        .catch(error => {
          this.setState({
            loadingBtn: false,
            message: readableResponseMessage(error)
          });
        });
    } else {
      this.setState({ message: "Please complete your email address" });
    }
  };

  render() {
    return (
      <div className="row center justify-content-center">
        <div className="col-md-6 col-sm-12">
          <h2>Verify Account</h2>
          {this.state.message ? (
            <p className="error">{this.state.message}</p>
          ) : (
            ""
          )}
          {this.state.successfulResendCode ? (
            <div>
              <p className="success">
                We have successfully resent your code to{" "}
                {this.props.userProps.emailAddress}. Please check your email.
                &#x2714;
              </p>
            </div>
          ) : (
            <p>Please check your email for a verification Code.</p>
          )}
          <FieldGroup
            control={this.verifyAccountForm}
            render={({ value, submitted }) => (
              <form
                name="Verify Account"
                id="login-verify-account-form"
                onSubmit={e => this.handleSubmit(e, value)}
                autoComplete="off"
              >
                <FieldControl
                  name="emailAddress"
                  formState={
                    this.props.userProps.emailAddress
                      ? this.props.userProps.emailAddress
                      : ""
                  }
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <input
                        className="form-control"
                        type={
                          this.props.userProps.emailAddress ? "hidden" : "text"
                        }
                        {...handler()}
                      />
                      <label
                        htmlFor="emailAddress"
                        className={`label ${pristine ? "" : "notEmpty"}`}
                      >
                        Email Address
                        <span className="error">
                          {(touched || submitted) &&
                            hasError("required") &&
                            " - Required"}
                        </span>
                      </label>
                    </div>
                  )}
                />
                <FieldControl
                  name="verificationCode"
                  render={({ handler, touched, hasError, pristine }) => (
                    <div className="inputContainer">
                      <input className="form-control" {...handler()} />
                      <label
                        htmlFor="verificationCode"
                        className={`label ${pristine ? "" : "notEmpty"}`}
                      >
                        Verification Code
                        <span className="error">
                          {(touched || submitted) &&
                            hasError("required") &&
                            " - Required"}
                        </span>
                      </label>
                    </div>
                  )}
                />
                <button
                  className={`${this.state.loadingBtn ? "btn-text-hide" : ""}`}
                  type="submit"
                  disabled={this.state.loadingBtn}
                >
                  Submit
                  <span
                    className={`${this.state.loadingBtn ? "loader" : ""}`}
                  />
                </button>
                <button type="button" onClick={() => this.resendCode()}>
                  Resend Code
                </button>
                <p>
                  Back to <Link to="/"> Sign In </Link>
                </p>
              </form>
            )}
          />
        </div>
      </div>
    );
  }
}

VerifyAccount.propTypes = {
  setParentState: PropTypes.func.isRequired,
  userProps: PropTypes.shape({
    emailAddress: PropTypes.string
  })
};

VerifyAccount.defaultProps = {
  userProps: {}
};
